import { UnitPCVStatus } from '../enums/UnitPcvEnum';

export interface StatusOption {
  value: UnitPCVStatus;
  label: string;
}

export const STATUS_LABELS: Record<UnitPCVStatus, string> = {
  [UnitPCVStatus.CREATED]: 'Creado',
  [UnitPCVStatus.DISABLED]: 'Deshabilitado',
  [UnitPCVStatus.TAKEN]: 'Tomado',
  [UnitPCVStatus.AVAILABLE]: 'Disponible',
  [UnitPCVStatus.ASSIGNED]: 'Asignado',
  [UnitPCVStatus.ON_DEED]: 'Escriturado',
  [UnitPCVStatus.SOLD_EXTERNAL]: 'Vendido externo',
  [UnitPCVStatus.TRANSFERRED]: 'Transferido',
};

export const STATUS_TRANSITIONS: Partial<
  Record<UnitPCVStatus, UnitPCVStatus[]>
> = {
  [UnitPCVStatus.CREATED]: [
    UnitPCVStatus.DISABLED,
    UnitPCVStatus.AVAILABLE,
    UnitPCVStatus.SOLD_EXTERNAL,
  ],
  [UnitPCVStatus.AVAILABLE]: [
    UnitPCVStatus.DISABLED,
    UnitPCVStatus.SOLD_EXTERNAL,
  ],
  [UnitPCVStatus.DISABLED]: [UnitPCVStatus.AVAILABLE],
  [UnitPCVStatus.SOLD_EXTERNAL]: [UnitPCVStatus.AVAILABLE], //for testing
};

export const getAllowedStatusOptions = (
  currentStatus: string,
): StatusOption[] => {
  const allowed = STATUS_TRANSITIONS[currentStatus as UnitPCVStatus] ?? [];
  return allowed.map((s) => ({ value: s, label: STATUS_LABELS[s] }));
};
